import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom"; // Χρήση navigate για redirect
import { useLanguage } from "../tools/LanguageContext"; // Για διγλωσσία

function Register() {
  const [formData, setFormData] = useState({ username: "", email: "", password: "" });
  const { translations } = useLanguage(); // Ανάκτηση μεταφράσεων
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post("https://artofbetting.gr/api/register", formData);

      if (response.status === 201) {
        alert(translations.alertSuccessRegister); // Alert για επιτυχή εγγραφή
        navigate("/"); // Redirect στο home
      }
    } catch (error) {
      if (error.response?.status === 400) {
        alert(translations.alertUsernameExists); // Alert για υπάρχον όνομα χρήστη
      } else if (error.response?.status === 401) {
        alert(translations.alertEmailExists); // Alert για υπάρχον email
      }
      else {
        alert(translations.alertServerError); // Alert για σφάλμα διακομιστή
      }
    }
  };

  return (
    <div className="bg-gray-900 text-white min-h-screen flex justify-center items-center">
      <form onSubmit={handleSubmit} className="bg-gray-800 p-6 rounded shadow-lg">
        <h2 className="text-2xl font-bold mb-4">{translations.register}</h2>
        <div className="mb-4">
          <label className="block text-sm mb-1">{translations.username}</label>
          <input
            type="text"
            name="username"
            value={formData.username}
            onChange={handleChange}
            className="w-full px-3 py-2 rounded bg-gray-700 text-white"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm mb-1">{translations.email}</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full px-3 py-2 rounded bg-gray-700 text-white"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm mb-1">{translations.password}</label>
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            className="w-full px-3 py-2 rounded bg-gray-700 text-white"
            required
          />
        </div>
        <button type="submit" className="bg-green-800 px-4 py-2 rounded hover:bg-green-900">
          {translations.register}
        </button>
      </form>
    </div>
  );
}

export default Register;
